export const WA_LINK =
  "https://wa.me/919004250500?text=Hi%2C%20I%20want%20to%20book%20a%20massage%20session%0ALocation%3A%0APreferred%20Time%3A%0AService%3A";
export const CALL_LINK = "tel:+919004250500";
export const EMAIL = "jraj06272@gmail.com";

export const SERVICES = {
  therapeutic: [
    {
      name: "Deep Tissue Massage",
      description: "Targets deep muscle layers to release chronic tension and knots.",
      price: 3000,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/myi70npb_WhatsApp%20Image%202026-04-15%20at%2016.42.55.jpeg",
    },
    {
      name: "Swedish Massage",
      description: "Classic long strokes for full-body stress relief and circulation.",
      price: 3000,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/wvtwwg5e_male_to_male_202604181208%20%281%29.png",
    },
    {
      name: "Trigger Point Therapy",
      description: "Precise pressure on specific muscle knots for targeted relief.",
      price: 3000,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/ox4fppdt_male_to_male_202604151815%20%285%29.png",
    },
    {
      name: "Sports Massage",
      description: "Enhances athletic performance and accelerates muscle recovery.",
      price: 3500,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/iglzf1gy_male_to_male_202604181208.png",
    },
    {
      name: "Pain Relief Therapy",
      description: "Targeted therapy for chronic pain, stiffness, and aches.",
      price: 4000,
      image: "https://images.unsplash.com/photo-1701916672756-615f56fb0d4e?w=600&q=80",
    },
  ],
  relaxation: [
    {
      name: "Thai Massage",
      description: "Ancient stretching and pressure techniques to restore energy flow.",
      price: 4000,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/cmac32tv_male_to_male_202604151815%20%281%29.png",
    },
    {
      name: "Balinese Massage",
      description: "Tropical techniques blending acupressure and aromatherapy.",
      price: 4500,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/3eoq15z6_WhatsApp%20Image%202026-04-13%20at%2018.40.35.jpeg",
    },
    {
      name: "Aromatherapy Massage",
      description: "Pure essential oils with soothing strokes for deep relaxation.",
      price: 4500,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/4rgowf7u_male_to_male_202604151815%20%284%29.png",
    },
    {
      name: "Signature Relaxation",
      description: "Our exclusive blend for total mind-body harmony and calm.",
      price: 4500,
      image: "https://images.unsplash.com/photo-1611920630912-43e092ae5c17?w=600&q=80",
    },
    {
      name: "Full Body Relaxation",
      description: "Head-to-toe relaxation massage for complete rejuvenation.",
      price: 4000,
      image: "https://customer-assets.emergentagent.com/job_wellness-andheri/artifacts/cmac32tv_male_to_male_202604151815%20%281%29.png",
    },
  ],
  premium: [
    {
      name: "Premium Holistic Therapy",
      description: "Comprehensive holistic wellness experience tailored for you.",
      price: 8000,
      image: "https://images.unsplash.com/photo-1761470575018-135c213340eb?w=600&q=80",
    },
    {
      name: "Advanced Intimate Therapy",
      description: "Personalized premium therapeutic session on request.",
      price: 7500,
      image: "https://images.unsplash.com/photo-1647535662084-ae98e675d35d?w=600&q=80",
    },
    {
      name: "Men's Deep Wellness Therapy",
      description: "Specialized deep wellness therapy crafted for men.",
      price: 7500,
      image: "https://images.unsplash.com/photo-1667786050496-c07e1d025a9b?w=600&q=80",
    },
  ],
};

export const TESTIMONIALS = [
  {
    rating: 5,
    text: "Amazing massage received by Raj — very strong hands to remove all the knots and stiffness, and a lot of knowledge about the body in general. I highly recommend!",
  },
  {
    rating: 5,
    text: "Great deep tissue massage. It really helped with muscle recovery after training. Professional and relaxing experience.",
  },
  {
    rating: 5,
    text: "I've been going to Raj for massages for about two years now and he's always been kind, professional and really accommodating. His place is well-maintained, nicely air conditioned and very convenient. He was even happy to come over to my hotel near Mumbai airport. Would definitely recommend him.",
  },
  {
    rating: 5,
    text: "I am very impressed with the quality of service here. The place is clean, organized, and has a calming ambience. The therapist was attentive and experienced. The massage helped release all the stress from my body. Will definitely visit again.",
  },
  {
    rating: 5,
    text: "Raj was great. Offered an all-round deep tissue massage and even helped with nasal blockages and pressure point activation. I felt more loose, flexible and less tension in targeted areas. I even felt an improvement with my breathing. Very beneficial and thorough.",
  },
  {
    rating: 5,
    text: "Raj's Muscle Care Studio has a special place in my wellness journey. The deep tissue massages are both therapeutic and relaxing. The therapists are adept at targeting problem areas, and I always feel a significant release of tension after each session.",
  },
  {
    rating: 5,
    text: "The therapists at Raj's Muscle Care Studio are incredibly skilled and attentive. My muscle pain has significantly improved since I started coming here.",
  },
  {
    rating: 5,
    text: "I've been to many massage studios, but Raj's Muscle Care Studio stands out for its exceptional deep tissue massages. The results have been outstanding — noticeable reduction in muscle soreness and improved flexibility.",
  },
  {
    rating: 4.5,
    text: "Raj's Muscle Care Studio offers the best trigger point massage I've ever experienced. The therapists are knowledgeable, caring, and truly professional.",
  },
];

export const FAQS = [
  {
    q: "Do you provide male to male massage in Mumbai?",
    a: "Yes, professional massage therapy for men is available at home, hotel and private studio.",
  },
  {
    q: "Where are you located?",
    a: "Our studio is in Andheri East & West, just 15 minutes from Mumbai Airport — very convenient for travellers.",
  },
  {
    q: "Do you provide hotel massage service?",
    a: "Yes, we offer in-room hotel massage service near Mumbai Airport and across Andheri.",
  },
  {
    q: "What are the charges?",
    a: "Sessions start from ₹3,000 depending on the service chosen. Premium therapies are available from ₹7,500.",
  },
  {
    q: "What are your working hours?",
    a: "Studio service is available from 8:00 AM to 11:30 PM, all days. Late night hotel service is available on request.",
  },
];
